import { MutableState } from '../State';
import { cleanupReceivedInterval, cleanupSendInterval } from './gifts.ruleset';
import { getGiftGemsCollectedToday } from './gifts.getters';
import * as Inventory from '../inventory';
import { CurrencyReplicantAPI } from '../inventory/inventory.utils';
import { CurrencyGrantFeature } from '../analytics/events';

/**
 * Add gems from a gift and count them towards today's collection.
 *
 * Counts only. The daily cap is enforced on the client (#12235).
 */
export function addGiftGems(
  state: MutableState,
  gems: number,
  now: number,
  feature: CurrencyGrantFeature,
  api: CurrencyReplicantAPI,
): void {
  state.gifts.collected = {
    gems: getGiftGemsCollectedToday(state, now) + gems,
    collectedAt: now,
  };

  Inventory.modifiers.addFreeGems(state, gems, feature, api);
}

export function removeGift(state: MutableState, senderId: string): void {
  delete state.gifts.received[senderId];
}

export const cleanupSentGifts = (state: MutableState, now: number) =>
  cleanupGifts(state.gifts.sent, now, cleanupSendInterval);

export const cleanupReceivedGifts = (state: MutableState, now: number) =>
  cleanupGifts(state.gifts.received, now, cleanupReceivedInterval);

function cleanupGifts(
  gifts: MutableState['gifts']['sent' | 'received'],
  now: number,
  interval: number,
) {
  const userIds = Object.keys(gifts);

  for (let index = 0; index < userIds.length; index++) {
    const id = userIds[index];
    const gift = gifts[id];
    const cleanupDate = gift.sentAt + interval;

    if (now >= cleanupDate) {
      delete gifts[id];
    }
  }
}
